import { isPlatformServer } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, LOCALE_ID, PLATFORM_ID } from '@angular/core';
import { ONBOARDING_API_CONFIG, OnboardingApiConfigInterface } from '@planone/bau365/data-access-onboarding';
import { catchError, map, Observable, of } from 'rxjs';

import { FAIRS_CONFIGURATION, FairsConfiguration } from '../../interfaces/environment.interfaces';
import { Fair } from '../../interfaces/fair.interfaces';

@Injectable()
export class DataAccessFairsService {
  constructor(
    private httpClient: HttpClient,
    @Inject(LOCALE_ID) private locale: string,
    @Inject(ONBOARDING_API_CONFIG)
    private onboarding_api_config: OnboardingApiConfigInterface,
    @Inject(PLATFORM_ID) private platformId: string,
    @Inject(FAIRS_CONFIGURATION) private fairsConfiguration: FairsConfiguration
  ) {}

  getFair(fairId: string | undefined) {
    const request = this.httpClient.get<Fair>(`${this.onboarding_api_config.fairDataGatewayUrl}/fairs/${fairId}`);

    if (isPlatformServer(this.platformId)) {
      return request.pipe(
        map((result) => result),
        catchError(() =>
          of({
            id: fairId ? fairId : 'unknown',
            name: 'Unknown',
          })
        )
      );
    }

    return request;
  }

  getFairsConfig(): Observable<FairsConfiguration> {
    return of(this.fairsConfiguration);
  }
}
